export const LANDING_PAGE_ROUTE = '/login';

export const SPARKRX_PDT_UID = '8dpNPSmSnyN3vxeBi4RtM9';
export const SLEEPIO_PDT_UID = 'BxgXBrgwswcX58wFNwhVfv';
export const SLEEPIORX_PDT_UID = 'nRDcAS9wCDUpe5ggJ2M7Ya';
export const DAYLIGHT_PDT_UID = 'DhZzR9fNJyNGMETp6Qgr6K';
export const DAYLIGHT_PLATGEN_PDT_UID = 'WcLGEey8ZMtnpoKBDrWH26';

// https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s01.html
// eslint-disable-next-line
export const EMAIL_VALIDATION_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

// https://ihateregex.io/expr/phone/
export const PHONE_VALIDATION_REGEX = /^[+]?\(?\d{3}\)?[-\s.]?\d{3}[-\s.]?\d{4,6}$/i;

// Validates this format: MM/DD/YYYY
export const DOB_VALIDATION_REGEX = /(?:(09|04|06|11)(\/)(0[1-9]|[12]\d|30)(\/)((?:19|20)\d\d))|(?:(01|03|05|07|08|10|12)(\/)(0[1-9]|[12]\d|3[01])(\/)((?:19|20)\d\d))|(?:02(\/)(?:(?:(0[1-9]|1\d|2[0-8])(\/)((?:19|20)\d\d))|(?:(29)(\/)((?:(?:19|20)(?:04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96))|2000))))/; // eslint-disable-line

// Validates zipcodes in these formats: #####
export const ZIPCODE_VALIDATION_REGEX = /^(\d{5})$/;

/* Validates password with these rules:
 - 8-24 characters
 - Include letters, numbers, and special characters
 */
export const PASSWORD_VALIDATION_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,24}$/;

export const EN = 'EN';
export const ES = 'ES';

export const LANGUAGE_LIST = [
  { value: EN, label: 'English' },
  { value: ES, label: 'Español' },
];

export const MINIMUM_BIRTH_YEAR = 1900;

export const SINGULAR_SDK_KEY = 'bighealth_8b9fd55c';
export const SINGULAR_SDK_SECRET = 'c65265155b6d1a8de24c00a5570aad38';

export const EMPLOYER_ORG_SLUG_KEY = 'employer_org_slug';
export const REDIRECT_TO_SESSION_KEY = 'cap_redirect_to';
export const ACCESS_CODE_SESSION_KEY = 'cap_access_code';
export const DEPENDENT_ACTIVATION_DATA_KEY = 'dependent_activation_data';

export type LineOfBusiness = 'wellness' | 'rx';

/**
 * Sleepio Activation Flow A/B Experiment
 *
 * - VARIANT_A: LineStep - horizontal progress bar with 3 lines
 * - VARIANT_B: ListStep - numbered list showing steps with durations
 */
export const VARIANT_A = 'variant-a';
export const VARIANT_B = 'variant-b';

export const ONBOARDING_STEPS = [
  { titleKey: 'onboarding.steps.verify_email', durationKey: 'onboarding.steps.duration_30_seconds' },
  { titleKey: 'onboarding.steps.confirm_coverage', durationKey: 'onboarding.steps.duration_1_minute' },
  { titleKey: 'onboarding.steps.download_sleepio', durationKey: 'onboarding.steps.duration_1_minute' },
];
